import { ComputedRef } from 'vue';

export enum ModuleVariant {
  Box = 'box',
  Table = 'table',
  /**
   * @deprecated Card Modules are no longer a thing. You're probably looking for `<RadioGroup variant="card">`.
   */
  Card = 'card',
  /**
   * @deprecated Only used with deprecated ListView component. Use `table` variant with `Table` component instead.
   */
  List = 'list',
}

export type ModuleVariants = `${ModuleVariant}`;

export interface ModuleInjection {
  /**
   * Module variant applied.
   */
  variant?: ComputedRef<ModuleVariants>;
  includeDataviewPagination?: ComputedRef<boolean>;
}
